let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1bKd7")).then(() => parcelRequire('dY8bj'));